import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="relative pt-6 pb-6 md:pt-32 md:pb-24 px-4 overflow-hidden bg-white" data-id="element-73">
      {/* Background subtle glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-celeste/10 rounded-full blur-[120px] pointer-events-none" data-id="element-74"></div>

      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center relative z-10" data-id="element-75">
        {/* Left Column: Copy */}
        <div className="flex flex-col space-y-3 md:space-y-8" data-id="element-76">
          <FadeIn data-id="element-77">
            <div className="inline-flex items-center space-x-2 bg-gray-50 border border-celeste/30 rounded-full px-4 py-1.5 mb-2 md:mb-4" data-id="element-78">
              <span className="flex h-2 w-2 rounded-full bg-celeste animate-pulse" data-id="element-79"></span>
              <span className="text-xs font-bold text-celeste tracking-wider uppercase" data-id="element-80">
                Sistema Probado Con 8 Años De Experiencia
              </span>
            </div>
            <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-black leading-[1.1] uppercase tracking-tight mb-2 md:mb-4" data-id="element-81">
              <span className="text-celeste block glow-celeste-text" data-id="element-82">
                CHAU VAPE
              </span>
              <span className="text-gray-900" data-id="element-83">Dejá el vape en 30 días</span>
            </h1>
            <p className="text-lg md:text-2xl text-gray-600 font-medium" data-id="element-84">
              Sin parches. Sin pastillas. Sin chamuyo. Un sistema real para los
              que ya lo intentaron todo y no pudieron.
            </p>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-85">
            <div className="flex justify-center mb-2 md:mb-4" data-id="element-86">
              <img src="https://cdn.magicpatterns.com/uploads/7gCMePbwM7hEWfKmkEbTir/chau_vape_ebook_5.png" alt="CHAU VAPE - Dejá el vapeo en 30 días" className="w-full md:w-80 rounded-xl shadow-[0_10px_40px_rgba(14,165,233,0.15)]" data-id="element-87" />
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-88">
            <div className="flex flex-wrap gap-2 md:gap-4 text-sm md:text-base text-gray-700 font-medium" data-id="element-89">
              <span className="bg-gray-50 px-3 py-1.5 rounded-full border border-gray-200" data-id="element-90">
                🇦🇷 Adaptado a Argentina
              </span>
              <span className="bg-gray-50 px-3 py-1.5 rounded-full border border-gray-200" data-id="element-91">
                ✅ 100% Real
              </span>
              <span className="bg-gray-50 px-3 py-1.5 rounded-full border border-gray-200" data-id="element-92">
                🚫 Sin humo motivacional
              </span>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} className="bg-gray-50 p-4 md:p-6 rounded-xl border border-gray-200 relative" data-id="element-93">
            <div className="absolute -top-3 -left-3 text-4xl text-celeste opacity-50" data-id="element-94">
              "
            </div>
            <p className="text-gray-700 italic relative z-10" data-id="element-95">
              Tuve una de las tiendas de vape más grandes de Argentina. Vendía
              esto todos los días… y era mi mejor cliente.
            </p>
          </FadeIn>
        </div>

        {/* Right Column: Visual/Placeholder */}
        <FadeIn direction="left" delay={0.3} className="relative hidden lg:block" data-id="element-96">
          <div className="aspect-square bg-gray-50 rounded-2xl border border-gray-200 overflow-hidden relative" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/mKcsEZJtNtyHocdEXcbqMc/ebook_chau_vape_2.jpg" alt="Creador de CHAU VAPE en su tienda de vape" className="w-full h-full object-cover" data-id="element-98" />

            {/* Decorative elements */}
            <div className="absolute top-10 right-10 w-20 h-20 bg-celeste/20 rounded-full blur-2xl" data-id="element-99"></div>
            <div className="absolute bottom-10 left-10 w-32 h-32 bg-celeste/10 rounded-full blur-3xl" data-id="element-100"></div>
          </div>
        </FadeIn>
      </div>
    </section>;
}